<template>
  <!-- todo : clean up style and template -->
  <!-- todo : redesign todo item in figma and push to production -->
  <!-- todo : put animation on dropdown expansion -->
  <base-list-item class="to-do-item" @click.self="toggleExpansion">
    <round-button-with-icon
      :icon="toDo.completed ? 'checkmark' : 'empty-circle'"
      @click="clickToDo(toDo)"
    />
    <h5 :class="toDo.completed ? `strike` : ``">{{ toDo.title }}</h5>
    <div class="people-wrapper">
      <profile-picture
        v-for="(contact, index) in contacts"
        :key="index"
        class="profile-picture"
        :profilePicture="contact ? contact.profilePicture : undefined"
      />
    </div>
  </base-list-item>
  <div class="expanded-to-do" v-if="expansionActive">
    <div
      class="to-do-contact-item"
      v-for="(contact, index) in contacts"
      :key="index"
    >
      <to-do-item-person-item :contact="contact" />
    </div>
  </div>
</template>

<script>
import BaseListItem from "../BaseListItem.vue";
import RoundButtonWithIcon from "../../../UI/RoundButtonWithIcon.vue";
import ToDoItemPersonItem from "./ToDoItemPersonItem.vue";
import ProfilePicture from "../ListItemComponents/ProfilePicture.vue";
export default {
  data() {
    return {
      expansionActive: false,
      contacts: [],
    };
  },
  methods: {
    toggleExpansion() {
      this.expansionActive = !this.expansionActive;
    },
    clickToDo(toDo) {
      toDo.completed = !toDo.completed;
      this.$store.dispatch("completeToDo", {
        id: toDo.userId,
        variable: "completed",
        value: toDo.completed,
      });
    },
  },
  async created() {
    this.contacts = await Promise.all(
      this.toDo.associatedContacts.map(async (x) => {
        let userId = x.key ? x.key.userId : x;
        let tenantId = x.key ? x.key.tenantId : this.toDo.tenantId;
        let key = { userId, tenantId };
        let contact = await this.$store.dispatch("getContactListItem", key);
        if (contact) {
          return contact;
        } else {
          return x;
        }
      })
    );
  },
  props: ["toDo", "listType"],
  components: {
    ProfilePicture,
    ToDoItemPersonItem,
    RoundButtonWithIcon,
    BaseListItem,
  },
};
</script>

<style scoped>
.to-do-item {
  margin: 15px 0;
  height: 30px;
  display: flex;
  align-items: center;
  overflow: visible;
}

h5 {
  margin: 10px;
  font-size: 0.75em;
}

.people-wrapper {
  margin: 0 10px;
  width: fit-content;
  overflow: visible;
  display: flex;
}

.profile-picture {
  width: 18px;
  height: 18px;
  margin: 0px 0px 0px -10px;
  display: flex;
  align-items: center;
  justify-content: center;
  fill: var(--foregroundColor);
}

.expanded-to-do {
  margin-bottom: 25px;
}

@keyframes strike {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}
.strike {
  position: relative;
}
.strike::after {
  content: " ";
  position: absolute;
  top: 50%;
  left: 0;
  height: 1px;
  background: var(--contrastColor);
  animation-name: strike;
  animation-duration: 0.3s;
  animation-timing-function: linear;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
}
</style>
